'use client';

import { FunctionComponent, useState } from 'react';
import { useTranslate } from '@xFrame4/components/Hooks';
import AButton from '@components/common/AButton';
import SpecialOfferContactForm from '@components/contact/SpecialOfferContactForm';
import SpecialOffer from '@business/offers/SpecialOffer';

export interface SpecialOfferContactSectionProps
{
    /** The special offer (JSON serialized) */
    specialOffer: any;
    /** The current language */
    language: string;
}

/**
 * Component: displays a contact button and handles the special offer contact form modal
 */
const SpecialOfferContactSection: FunctionComponent<SpecialOfferContactSectionProps> = (props) =>
{
    const t = useTranslate();
    const [showContactForm, setShowContactForm] = useState(false);
    
    // Deserialize the special offer from JSON
    const specialOffer = SpecialOffer.createFromJson(props.specialOffer) as SpecialOffer;

    /** Render */
    return (
        <>
            <div className="mt-5">
                <AButton 
                    text={t('REQUEST_QUOTE')}
                    size="lg"
                    className="w-100"
                    variant="primary"
                    textColor="white"
                    onClick={() => setShowContactForm(true)}
                />
            </div>

            <SpecialOfferContactForm
                specialOffer={specialOffer}
                language={props.language}
                show={showContactForm}
                onHide={() => setShowContactForm(false)}
            />
        </>
    );
}

export default SpecialOfferContactSection;